export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9977.60c05591.jpg";